import script from "./deliverables.vue?vue&type=script&setup=true&lang=ts"
export * from "./deliverables.vue?vue&type=script&setup=true&lang=ts"

import "./deliverables.vue?vue&type=style&index=0&id=543340f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-543340f0"]])

export default __exports__